<div id="suggested-users">
  <div class="container">
    <mat-card class="row">
      <div class="box rounded">
        <div class="box-title border-bottom pl-3 pr-2 py-2 mb-1 d-flex justify-content-between">
          <h6 class="d-flex align-self-center m-0 text-success font-weight-bold">
            <i class="fas fa-user-friends"></i>&nbsp;Scribers To Follow</h6>
          <button mat-icon-button aria-label="refresh suggested users" (click)="getSuggestedUsers()">
            <mat-icon style="font-size: 20px;">refresh</mat-icon>
          </button>
        </div>
        <div class="box-body py-1 px-2">
          <mat-progress-bar mode="indeterminate" *ngIf="peopleToFollowLoading$ | async"></mat-progress-bar>
          <div *ngIf="peopleToFollowError$ | async">
            <img class="w-75 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-users.svg">
            <!-- <h6>An error occurred while loading people to follow</h6> -->
          </div>
          <h6 *ngIf="!(isAuthenticated$ | async)">Login to see people to follow</h6>

          <div *ngFor="let personState of (peopleToFollowState$ | async)">
            <div class="d-flex align-items-center mb-3">
              <div class="su-image mr-2 rounded-circle border pr-cursor" routerLink="/{{personState?.user?.handle}}">
                <img class="rounded-circle" [src]="personState?.user?.photoURL || './assets/images/profile.jpg'"
                  alt="avatar">
                <!--  <div class="su-status-indicator"></div>-->
                <div></div>
              </div>
              <div class="font-weight-bold mr-2 pr-cursor" routerLink="/{{personState?.user?.handle}}">
                <div class="su-truncate">{{personState?.user?.name}}</div>
                <div class="small text-muted su-truncate">@{{personState?.user?.handle}}</div>
              </div>
              <span class="ml-auto">
                <button *ngIf="!personState?.following" (click)="followUser(personState?.user?.ID)" mat-icon-button
                color="primary" matTooltip="Follow" matTooltipPosition="before">
                  <mat-icon>person_add_alt_1</mat-icon>
                </button>
                <button *ngIf="personState?.following" (click)="unFollowUser(personState?.user?.ID)" mat-icon-button
                color="accent" matTooltip="Unfollow" matTooltipPosition="before">
                  <mat-icon>person_remove_alt_1</mat-icon>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="border-top p-2">
        <a routerLink="/connect">
          <h6 class="text-center text-success">View More</h6>
        </a>
      </div>
    </mat-card>
  </div>
</div>
